import { dayLabel } from "@/lib/api";

export const DayTabs = ({ days, value, onChange, prefix = "day" }) => (
  <div className="flex flex-wrap gap-2 pb-1 no-print">
    {days.map((d) => (
      <button
        key={d}
        data-testid={`${prefix}-tab-${d.toLowerCase().replace(/[^a-z0-9ąćęłńóśźż]+/g, "-")}`}
        onClick={() => onChange(d)}
        className={`shrink-0 px-4 h-10 rounded-full text-sm font-semibold border transition-[background-color,border-color,color] duration-150 ${
          value === d ? "bg-blue-600 border-blue-500 text-white" : "border-blue-500/20 text-slate-400 hover:text-white hover:border-blue-500/50"
        }`}
      >
        {dayLabel(d)}
      </button>
    ))}
  </div>
);
